import React from 'react';
import {
  createStyles, Theme, WithStyles, withStyles,
} from '@material-ui/core/styles';
// import PropTypes from 'prop-types';
// @ts-ignore
import ReactTable from 'react-table';
import {injectIntl, WrappedComponentProps} from 'react-intl';
import 'react-table/react-table.css';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';

// @ts-ignore
import ImportanceMeasureContent from "./ImportanceMeasureContent";
import {QRLabelMapJSON} from "../../Quantification/QuantificationResultJSON";

const styles = (theme: Theme) => createStyles({
  darker: {
    background: theme.palette.type === 'dark' ? 'rgba(60,60,60,0.2)' : 'rgba(120,120,120,0.08)',
  },
  root: {
    height: '100%',
    margin: '0',
    overflow: 'auto',
    padding: '0',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
  },
  probContainer: {
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    height: '100%',
    marginTop: '0',
  },
  labelProb: {
    fontSize: '2rem',
    userSelect: 'all',
  },
  rootProb: {
    padding: '24px 0px',
  },
  cutsetChip: {
    margin: `0px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
  },
  cutsetRowItem: {
    flexDirection: 'row',
  },
  cutsetRow: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rowItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  subcomponent: {
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
    background: 'rgba(0, 0, 0, 0.03)',
  },
});

interface QuantificationResultResponse {
  configuration?: {
    constructor: {
      tree_id: number;
    };
    engine: {
      BBNSolver: number;
      BDDConstructor: number;
      OrderingRule: number;
    };
    quantify: {
      targets: string;
    };
  };
  creator?: number;
  date_created?: string;
  id?: number;
  model?: number;
  model_title?: string;
  result_data?: {[index: string]: any};
  importance?: {[index: string]: any};
  map: QRLabelMapJSON;
}

interface Props extends WithStyles<typeof styles>, WrappedComponentProps {
  noSlide: boolean;
  title: string;
  loading: boolean;
  loadingText: string;
  noDataText: string;
  data: QuantificationResultResponse;
  treeType: string;
  sequenceName: string;
  importanceData: string;
}

interface State {
  importanceIdx: number;
  keyIdx: number;
}

class ImportanceMeasureView extends React.Component <Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {importanceIdx:0, keyIdx:0};
  }

  render() {

    const {intl, classes, data, title, noDataText, noSlide, treeType, sequenceName, ...others} = this.props;

    const isDataEmpty = data === undefined || data === null || Object.keys(data).length === 0 || data.result_data === null || Object.keys(data.result_data).length === 0;

    if (this.props.loading) {
      return (
        <div className={classes.root}>
          {this.props.loadingText}
        </div>
      );
    }

    if (isDataEmpty) {

      return (
        <Slide direction="up" in mountOnEnter unmountOnExit>
          <Paper className={classes.root} {...others} square elevation={0}>
            {noDataText}
          </Paper>
        </Slide>
      );
    }

    if (noSlide) {
      return (
        // @ts-ignore
        <ImportanceMeasureContent
          {...this.props}
        />
      );
    }

    return (
      <Slide direction="up" in mountOnEnter unmountOnExit>
        {/*
        // @ts-ignore */}
        <ImportanceMeasureContent
          {...this.props}
        />
      </Slide>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(injectIntl(ImportanceMeasureView));
